module.exports = __webpack_public_path__ + "static/media/no-areas.3f1fcd54.svg";